import { render, staticRenderFns } from "./TahsilatlarHaftaChart.vue?vue&type=template&id=d5a509a8&scoped=true"
import script from "./TahsilatlarHaftaChart.vue?vue&type=script&lang=ts"
export * from "./TahsilatlarHaftaChart.vue?vue&type=script&lang=ts"
import style0 from "./TahsilatlarHaftaChart.vue?vue&type=style&index=0&id=d5a509a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a509a8",
  null
  
)

export default component.exports